import { render, staticRenderFns } from "./organizationalDetail.vue?vue&type=template&id=e5ec111a&scoped=true"
import script from "./organizationalDetail.vue?vue&type=script&lang=js"
export * from "./organizationalDetail.vue?vue&type=script&lang=js"
import style0 from "./organizationalDetail.vue?vue&type=style&index=0&id=e5ec111a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ec111a",
  null
  
)

export default component.exports